var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-campaign-sharelink';
                    var viewUrl = 'gfx/sprite.svg#view-icon-campaign-sharelink';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };